'use strict';

import Vue from 'vue';
import Vuex from 'vuex';
import md5 from "md5";

const fields = [
    "userId", "name", "username", "password",
    "deptId", "deptName", "roleId", "roleName",
    "funcIds", "deptRoles", "roleParams", "passwordRaw"
];
const LSKEY = "__vuex_state_srmis_web__";

export default {
    getStoreFromStorage() {
        return JSON.parse(window.localStorage.getItem(LSKEY) || "{}")
    },

    getStore() {
        // console.log("in get Store.");

        // 从 sessionStorage 加载数据
        const last = JSON.parse(window.localStorage.getItem(LSKEY) || "{}");

        return new Vuex.Store({
            state: last,

            mutations: {
                login(state, payload) {
                    //console.log("in VueX login");

                    fields.forEach(p => Vue.set(state, p, payload[p]));

                    // funcIds 和 roleParams将在 "/" 加载时获取
                    //state.funcIds = [];
                    Vue.set(state, "funcIds", []);
                    // state.roleParams = [];
                    Vue.set(state, "roleParams", []);

                    window.localStorage.setItem(LSKEY, JSON.stringify(state));
                },
                logout(state) {
                    //console.log("in VueX logout");

                    fields.forEach(p => Vue.set(state, p, null));

                    // funcIds 和 roleParams将在 "/" 加载时获取
                    //state.funcIds = [];
                    Vue.set(state, "funcIds", []);
                    // state.roleParams = [];
                    Vue.set(state, "roleParams", []);

                    window.localStorage.removeItem(LSKEY);
                },
                changeRole(state, payload) {
                    // console.log("in VueX changeRole");

                    //state.deptId = payload.deptId;
                    Vue.set(state, "deptId", payload.deptId);

                    // state.deptName = payload.deptName;
                    Vue.set(state, "deptName", payload.deptName);

                    // state.roleId = payload.roleId;
                    Vue.set(state, "roleId", payload.roleId);

                    // state.roleName = payload.roleName;
                    Vue.set(state, "roleName", payload.roleName);


                    // funcIds 和 roleParams将在 "/" 加载时获取
                    //state.funcIds = [];
                    Vue.set(state, "funcIds", []);
                    // state.roleParams = [];
                    Vue.set(state, "roleParams", []);

                    window.localStorage.setItem(LSKEY, JSON.stringify(state));
                },
                funcsAndParams(state, payload) {
                    // console.log("in VueX funcIds");

                    //state.funcIds = payload.funcIds;
                    Vue.set(state, "funcIds", payload.funcIds);

                    //state.roleParams = payload.roleParams;
                    Vue.set(state, "roleParams", payload.roleParams);

                    window.localStorage.setItem(LSKEY, JSON.stringify(state));
                },
                updateUser(state, payload) {
                    Vue.set(state, "username", payload.username);

                    // state.deptName = payload.deptName;
                    Vue.set(state, "password", md5(payload.password));
                    Vue.set(state, "passwordRaw", payload.password);

                    window.localStorage.setItem(LSKEY, JSON.stringify(state));
                },
                updatePassword(state, payload) {
                    window.console.log(payload)
                    // state.deptName = payload.deptName;
                    Vue.set(state, "password", md5(payload));
                    Vue.set(state, "passwordRaw", payload);

                    window.localStorage.setItem(LSKEY, JSON.stringify(state));
                }
            },

            getters: {
                authenticated: state => state.userId != null,
                userId: state => state.userId,
                name: state => state.name,
                username: state => state.username,
                password: state => state.password,
                passwordRaw: state => state.passwordRaw,
                deptId: state => state.deptId,
                deptName: state => state.deptName,
                roleId: state => state.roleId,
                roleName: state => state.roleName,
                funcIds: state => state.funcIds,
                roleParams: state => state.roleParams,
                deptRoles: state => state.deptRoles
            }
        })
    }
}
